import React, { useContext } from "react";
import { Dialog } from "../DialogProvider";

import EditRoundedIcon from "@material-ui/icons/EditRounded";
import DeleteForeverRoundedIcon from "@material-ui/icons/DeleteForeverRounded";
import MoreVertRoundedIcon from "@material-ui/icons/MoreVertRounded";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const ForumMoreButton = (props) => {
  const {
    handleOpenDialog,
    setPostState,
    setCommentState,
    setFormlessState,
  } = useContext(Dialog);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menu = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDialog = (event) => {
    handleCloseMenu();
    switch (event.currentTarget.id) {
      case "toggle-edit-dialog":
        if (props.fromPost === false) {
          setPostState({ ...props });
          handleOpenDialog("EDIT_POST", "md");
          break;
        } else if (props.fromPost !== false) {
          setCommentState({ ...props });
          handleOpenDialog("EDIT_COMMENT", "sm");
          break;
        } else {
          break;
        }
      case "toggle-delete-dialog":
        if (props.fromPost === false) {
          setFormlessState({
            id: props.id,
            fromPost: props.fromPost,
            urlParam: props.urlParam,
          });
          handleOpenDialog("DELETE_POST", "sm");
          break;
        } else if (props.fromPost !== false) {
          setFormlessState({
            id: props.id,
            fromPost: props.fromPost,
          });
          handleOpenDialog("DELETE_COMMENT", "sm");
          break;
        } else {
          break;
        }
      default:
        break;
    }
  };

  return (
    <span>
      <Tooltip
        title="More"
        enterDelay={300}
        leaveDelay={200}
        enterNextDelay={300}
      >
        <span>
          <IconButton
            onClick={handleOpenMenu}
            aria-label="more"
            size="small"
            aria-controls="post-menu"
            aria-haspopup="true"
          >
            <MoreVertRoundedIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Menu
        id="post-menu"
        anchorEl={anchorEl}
        keepMounted
        open={menu}
        onClose={handleCloseMenu}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          id="toggle-edit-dialog"
          onClick={(e) => {
            handleDialog(e);
          }}
        >
          <ListItemIcon>
            <EditRoundedIcon />
          </ListItemIcon>
          <Typography component="span" noWrap>
            <Box display="inline">Edit</Box>
          </Typography>
        </MenuItem>
        <MenuItem
          id="toggle-delete-dialog"
          onClick={(e) => {
            handleDialog(e);
          }}
        >
          <ListItemIcon>
            <DeleteForeverRoundedIcon />
          </ListItemIcon>
          <Typography component="span" noWrap>
            <Box display="inline">Delete</Box>
          </Typography>
        </MenuItem>
      </Menu>
    </span>
  );
};

export default ForumMoreButton;
